<div class="flex items-start">
  <div class="flex-none">
    <input
      [id]="currentId"
      [(ngModel)]="value"
      [indeterminate]="indeterminate()"
      [disabled]="disabled()"
      class="h-5 w-5 rounded-md mt-0.5 disabled:opacity-50"
      type="checkbox"
      #checkboxElementRef
      />
  </div>
  @if (label()) {
    <div class="ml-3">
      <label [for]="currentId" [ngClass]="{'pointer-events-none': disabled()}" class="font-medium text-gray-700">{{label()}}</label>
      <div class="text-sm">
        <ng-content></ng-content>
      </div>
    </div>
  }
</div>
